import BALLOON from "@assets/emoji/ballon.png";
import SHOPPING_CART from "@assets/emoji/caddie.png";
import WAVING_HAND from "@assets/emoji/coucou.png";
import SPARKLES from "@assets/emoji/etincelles.png";
import PARTY from "@assets/emoji/fete.png";
import FIRE from "@assets/emoji/feu.png";
import ROCKET from "@assets/emoji/fusee.png";
import HAND from "@assets/emoji/main.png";
import THINKING from "@assets/emoji/pensif.png";
import PIN from "@assets/emoji/pin.png";
import HANDSHAKE from "@assets/emoji/poignee-de-main.png";
import THUMB_UP from "@assets/emoji/pousse-en-l-air.png";
import TROPHY from "@assets/emoji/trophee.png";
import { Image } from "@mantine/core";

import type { JSX } from "react";

const emojis = {
  Fire: FIRE,
  Balloon: BALLOON,
  ThumbUp: THUMB_UP,
  Pin: PIN,
  Handshake: HANDSHAKE,
  Sparkles: SPARKLES,
  Thinking: THINKING,
  Rocket: ROCKET,
  Waving: WAVING_HAND,
  Hand: HAND,
  ShoppingCart: SHOPPING_CART,
  Party: PARTY,
  Trophy: TROPHY,
  DYNAMIC: "",
};

export interface IEmojiProps {
  size?: number;
  className?: string;
  emoji?: keyof typeof emojis;
}

// eslint-disable-next-line react/display-name
const createEmoji = (emoji: string) => (props: IEmojiProps) => {
  const emojiName =
    emoji.split("/").pop()?.split(".")[0].replaceAll("-", " ") ?? emoji;
  return (
    <Image
      alt={`Emoji de ${emojiName}`}
      className={`inline-block pb-2 ${props.className}`}
      fit="contain"
      loading="lazy"
      src={emoji === "" && props.emoji ? emojis[props.emoji] : emoji} //if no emoji is provided, use the default emoji
      title={`Emoji de ${emojiName}`}
      w={props.size ?? 30}
    />
  );
};

const Emoji = Object.keys(emojis).reduce(
  (acc, key) => {
    const emojiKey = key as keyof typeof emojis;

    acc[emojiKey] = createEmoji(emojis[emojiKey]);
    return acc;
  },
  {} as Record<keyof typeof emojis, (props: IEmojiProps) => JSX.Element>,
);

export default Emoji;
